import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import nexumLogo2 from "../../assets/nexumLogo2.png";
import { FiBarChart } from "react-icons/fi";
import {
  LayoutGrid,
  Building2,
  ShoppingBag,
  ChevronRight,
  LogOut,
  User,
  MessageSquare,
} from "lucide-react";
import { DEFAULT_USER_ROLE } from "../../../utils/userUtils";

const Sidebar2 = ({
  onSidebarOpen,
}: {
  onSidebarOpen?: (isOpen: boolean) => void;
}) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const navigate = useNavigate();
  const location = useLocation(); // Add this to get current route
  const userRole = parseInt(
    window.localStorage.getItem("role") || DEFAULT_USER_ROLE,
    10
  );
  const isUser = window.localStorage.getItem("isUser") === "true";
  const isTenantUser = window.localStorage.getItem("isTenantUser") === "true";

  const sidebarVariants = {
    expanded: { width: "240px" },
    collapsed: { width: "80px" },
  };

  const isActiveRoute = (route: string) => {
    return location.pathname === route;
  };

  const MenuItem = ({
    to,
    icon: Icon,
    label,
  }: {
    to: string;
    icon: any;
    label: string;
  }) => {
    const isActive = isActiveRoute(to);

    return (
      <Link to={to}>
        <motion.li
          whileHover={{
            backgroundColor: isActive ? "#e3ebf6" : "rgba(255, 255, 255, 0.1)",
          }}
          whileTap={{ scale: 0.95 }}
          className={`flex items-center gap-4 pl-3 py-3 rounded-lg min-h-16 mb-3 rounded-r-none  cursor-pointer transition-colors duration-200
            ${isActive ? "bg-[#e3ebf6] text-[#0c1d46] text-center align-middle" : "text-white hover:bg-[#e3ebf6]"}`}
        >
          <Icon
            className={`w-6 h-6 ${isActive ? "text-[#0c1d46]" : "text-white"}`}
            style={{ marginLeft: !isExpanded ? "10px" : "0px" }}
          />
          <span
            className={`font-medium transition-colors duration-200 ${!isExpanded && "hidden"}`}
          >
            {label}
          </span>
        </motion.li>
      </Link>
    );
  };

  const organizzazioniMenuItem = () => {
    // Admin view
    if (userRole === 0) {
      return (
        <>
          {/* <MenuItem
            to="/private/dashboard"
            icon={LayoutGrid}
            label="Bacheca"
          /> */}
          <MenuItem
            to="/private/tenantlist"
            icon={Building2}
            label="Tenants List"
          />
          <MenuItem to="/private/userlist" icon={User} label="User List" />
          <MenuItem
            to="/private/admin-monitoring"
            icon={FiBarChart}
            label="Monitor purchase"
          />
        </>
      );
    }

    // Don't show anything for tenant users
    if (isTenantUser) {
      return null;
    }

    // Regular user view
    return (
      <MenuItem
        to={isUser ? "/private/userProfile" : "/private/multidetailstenant"}
        icon={isUser ? User : Building2}
        label={isUser ? "User Profile" : "Tenant"}
      />
    );
  };

  return (
    <motion.aside
      initial="expanded"
      animate={isExpanded ? "expanded" : "collapsed"}
      variants={sidebarVariants}
      transition={{ duration: 0.3, ease: "easeInOut" }}
      className="fixed top-0 left-0 h-screen bg-[#0c1d46] z-20"
    >
      <div className="flex flex-col h-full">
        {/* Toggle Button */}
        <motion.button
          whileHover={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}
          whileTap={{ scale: 0.95 }}
          onClick={() => {
            setIsExpanded(!isExpanded);
            onSidebarOpen && onSidebarOpen(!isExpanded);
          }}
          className="absolute -right-8 top-6 bg-white rounded-full p-1.5 shadow-md"
        >
          <motion.div
            animate={{ rotate: isExpanded ? 180 : 0 }}
            transition={{ duration: 0.3 }}
          >
            <ChevronRight className="w-4 h-4 text-[#0c1d46]" />
          </motion.div>
        </motion.button>

        {/* Logo */}
        <div className="flex justify-center py-6 mb-5">
          <img
            src={nexumLogo2}
            alt="nexum Logo"
            className={`${isExpanded ? "w-36" : "w-16"} transition-all duration-300`}
          />
        </div>

        {/* Navigation */}
        <nav className="flex-1 pl-2">
          <ul className={`space-y-2`}>
            {organizzazioniMenuItem()}

            {/* <MenuItem
              to="/private/productlistv2"
              icon={ShoppingBag}
              label="Prodotti old"
            /> */}
            <MenuItem
              to="/private/productlistv3"
              icon={ShoppingBag}
              label="Products"
            />

            <MenuItem
              to="/private/contactPage"
              icon={MessageSquare}
              label="Contact us"
            />
          </ul>
        </nav>

        {/* Bottom Section */}
        <div className="p-2 mt-auto">
          <motion.div
            whileHover={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}
            whileTap={{ scale: 0.95 }}
            onClick={() => {
              // Add your logout logic here
              localStorage.clear();
              window.location.assign("/");
            }}
            className="flex items-center gap-4 px-4 py-3 rounded-lg cursor-pointer text-white hover:bg-white/10"
          >
            <LogOut className="w-6 h-6" />
            <span className={`font-medium ${!isExpanded && "hidden"}`}>
              Sign Out
            </span>
          </motion.div>
        </div>
      </div>
    </motion.aside>
  );
};

export default Sidebar2;
